<template>
  <global-modal :active.sync="filter.isActive" @toggleActive="toggleActive">
    <div slot="header">
      <div class="font-semibold text-xl">Tambah Filter</div>
    </div>
    <div class="p-5">
      <div class="w-full mb-5">
        <div class="w-full mb-5">
          <label class="w-full mb-2">Filter Berdasarkan</label>
          <vs-select :options="filterOptions" @input="selectFilter" />
        </div>
        <div class="w-full" v-if="filter.input.type.value">
          <label class="w-full mb-2">Kata Kunci</label>
          <component
            :is="filter.selected.component"
            :options="filter.selected.options"
            :value="filter.input.query"
            @input="selectQuery"
          ></component>
        </div>
      </div>
      <div class="w-full">
        <vs-button color="primary" @click="pushFilterList" type="filled"
          >Tambah Filter</vs-button
        >
      </div>
    </div>
  </global-modal>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import vSelect from "vue-select";
export default {
  components: {
    "vs-select": vSelect
  },
  computed: {
    ...mapState({
      filter: state => state.globalApp.filter
    }),
    ...mapGetters({
      filterOptions: "globalApp/fetchFilterOptions",
      componentSelected: "globalApp/fetchComponentSelected"
    })
  },
  methods: {
    toggleActive() {
      this.$store.dispatch("globalApp/toggleFilter");
    },
    selectFilter({ label, value }) {
      this.$store.dispatch("globalApp/setFilterType", { label, value });
    },
    selectQuery(value) {
      this.$store.dispatch("globalApp/setFilterQuery", value);
    },
    pushFilterList() {
      let payload = {
        type: this.filter.input.type,
        query: this.filter.input.query
      };

      this.$store.dispatch("globalApp/submitFilter", payload);
    }
  }
};
</script>
